var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.text.length > _vm.length ? _vm.text : ``),expression:"text.length > length ? text : ``",modifiers:{"top-center":true}}]},[_vm._v("\n  "+_vm._s(_vm.text.substring(0, _vm.length))+_vm._s(_vm.text.length > _vm.length ? `...` : ``)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }